import {
	GridActionsCellItem,
	GridActionsCellItemProps,
	GridRowParams,
} from '@mui/x-data-grid-premium';

import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { selectIsCountLoading } from '@Selectors/Risk.selectors';
import { selectUniqueSelectedIds } from '@Selectors/util.selectors';

export const ActionCell = (
	params: GridRowParams,
	countKey: string,
	onExcludeActions: (excluded: boolean, id?: number) => void,
	onGroupActions: (group: boolean, id?: number) => void,
): React.ReactElement<GridActionsCellItemProps>[] => {
	const { t } = useGlobalization();
	const result = new Array<React.ReactElement<GridActionsCellItemProps>>();
	const selectedIds = selectUniqueSelectedIds();
	const isRiskCountLoading = selectIsCountLoading(countKey);

	// Only show this menu if one or fewer rows are selected
	if (selectedIds.length <= 1) {
		const id = params.row.id;
		if (params.row.grouped) {
			result.push(
				<GridActionsCellItem
					key={1}
					label={t('Ungroup')}
					onClick={() => {
						onGroupActions(false, id);
					}}
					showInMenu
					disabled={isRiskCountLoading}
				/>,
			);
		}

		if (params.row.excluded) {
			result.push(
				<GridActionsCellItem
					key={2}
					label={t('Include in Asset Group Set')}
					onClick={() => {
						onExcludeActions(false, id);
					}}
					showInMenu
					disabled={isRiskCountLoading}
				/>,
			);
		} else {
			result.push(
				<GridActionsCellItem
					key={3}
					label={t('Exclude from Asset Group Set')}
					onClick={() => {
						onExcludeActions(true, id);
					}}
					showInMenu
					disabled={isRiskCountLoading}
				/>,
			);
		}
	}

	return result;
};
